module.exports = __webpack_public_path__ + "static/main-01634caa26236c16459635b3b5b5aa69.png";